module.exports = {
	"articleTitle1": "Clements library reopens after $17 million in renovations ",
	"catImage": "bluestar.png",
	"totalCats": 2,
	"name": "William L. Clements Library",
	"articleLink1": "https://www.michigandaily.com/section/news/clements-library-re-opens-after-17-million-renovation",
	"articleLink2": "https://www.michigandaily.com/article/clements-library-undergo-renovations",
	"articleSnippet1": "Apr 11, 2016 ... After being closed for more than two years during a $17 million renovation, the \nWilliam Clements Library officially re-opened with a ribbon ...",
	"articleSnippet2": "Apr 9, 2013 ... In stark contrast to its “UGLi” neighbor, the Clements Library is known not only for \nits extensive collections, but also its intricate architecture: ...",
	"totalMisc": 1,
	"articleTitle2": "Clements library to receive $17M interior renovation",
	"address": "909 S University Ave, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160412/cea.NEW_.RibbonCutting.4.11.16.0436_0.jpg?itok=cnUdxjHq",
			"author:": "Claire Abdo",
			"caption": "University of Michigan President Mark Schissel, Director of William Clements Library Kevin Graffagnino, LSA student Christy Finkenstadet, and Chairman of William Clements Library Peter Heydon cut the ribbon to reopen the William Clements Library on Monday"
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170417/agc.NEW_.ClementsLibrary.4.13.17.0001.jpg?itok=7owwApKk",
			"author": "Amelia Cacchione",
			"caption": "Inside a meeting room at the Clements Library"
		}
	],
	"position": {
		"lat": 42.275438,
		"lng": -83.737991
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1,
		"library": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/clementslibrary.json
// module id = 851
// module chunks = 0